
import React, { useState, useEffect } from "react";
import { gameAPI } from "../lib/supabase";
import "../styles.css";

const Leaderboards = ({ gameMode = 'classic' }) => {
    const [leaderboard, setLeaderboard] = useState([]);
    const [dailyLeaderboard, setDailyLeaderboard] = useState([]);
    const [weeklyLeaderboard, setWeeklyLeaderboard] = useState([]);
    const [gameTitle, setGameTitle] = useState("");

    // Get game title based on mode
    useEffect(() => {
        const titles = {
            orientation: "UBC Orientation Challenge",
            classic: "Classic UBCguessr",
            challenge: "Challenge Mode"
        };
        setGameTitle(titles[gameMode] || titles.classic);
    }, [gameMode]);

    useEffect(() => {
        const loadLeaderboards = async () => {
            try {
                const [allTime, daily, weekly] = await Promise.all([
                    gameAPI.getLeaderboard(gameMode, 'all', 30),
                    gameAPI.getLeaderboard(gameMode, 'daily', 30),
                    gameAPI.getLeaderboard(gameMode, 'weekly', 30)
                ]);
                
                setLeaderboard(allTime);
                setDailyLeaderboard(daily);
                setWeeklyLeaderboard(weekly);
            } catch (error) {
                console.error('Error loading leaderboards:', error);
            }
        };

        loadLeaderboards();
    }, [gameMode]);

    return (
        <div className="leaderboards-page">
            <h1 className="game-mode-title">{gameTitle}</h1>
            <h2>Leaderboards</h2>
            <div className="leaderboards-container">
                <div className="leaderboard">
                    <h2>Daily Leaderboard (Top 30)</h2>
                    <h3>Resets Daily at 4pm</h3>
                    <table className="leaderboard-table">
                        <thead>
                            <tr>
                                <th>Score</th>
                                <th>Name</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dailyLeaderboard.length > 0 ? (
                                dailyLeaderboard.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{entry.score}</td>
                                        <td>{entry.name}</td>
                                        <td>{new Date(entry.date).toLocaleDateString()}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" style={{textAlign: 'center', fontStyle: 'italic', color: '#666'}}>No scores yet today</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="leaderboard">
                    <h2>Weekly Leaderboard (Top 30)</h2>
                    <h3>Resets Sundays at 4pm</h3>
                    <table className="leaderboard-table">
                        <thead>
                            <tr>
                                <th>Score</th>
                                <th>Name</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {weeklyLeaderboard.length > 0 ? (
                                weeklyLeaderboard.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{entry.score}</td>
                                        <td>{entry.name}</td>
                                        <td>{new Date(entry.date).toLocaleDateString()}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" style={{textAlign: 'center', fontStyle: 'italic', color: '#666'}}>No scores yet this week</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="leaderboard">
                    <h2>All-time Leaderboard (Top 30)</h2>
                    <h3>Persistent</h3>
                    <table className="leaderboard-table">
                        <thead>
                            <tr>
                                <th>Score</th>
                                <th>Name</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leaderboard.map((entry, index) => (
                                <tr key={index}>
                                    <td>{entry.score}</td>
                                    <td>{entry.name}</td>
                                    <td>{new Date(entry.date).toLocaleDateString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Leaderboards;